// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"2c58fa52","605":"d1372617","667":"6353366c","674":"fceb1e02","695":"145cc13a","829":"b11694d2","925":"4f034e44","952":"4f034e44"}[chunkId] + ".css";
};